import { Box, FormField, Input } from '@wix/design-system';
import React, { useContext } from 'react';
import { containsUrl } from 'ricos-content';
import { RicosContext } from 'ricos-context';
import { ButtonData_Type, Link_Target } from 'ricos-schema';
import { LinkSettings } from 'wix-rich-content-ui-components';
import { BUTTON_TEXT_INPUT } from '../dataHooks.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SettingsComponent = ({
  buttonData,
  onChange,
  inputRef,
  setIsValidUrl
}) => {
  var _a, _b, _c, _d, _e, _f;
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", gap: "SP3" }, /* @__PURE__ */ React.createElement(FormField, { label: t("ButtonModal_Button_Text") }, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      onChange: (e) => onChange(__spreadProps(__spreadValues({}, buttonData), { text: e.target.value })),
      value: buttonData.text,
      dataHook: BUTTON_TEXT_INPUT,
      placeholder: t("ButtonModal_InputName_Placeholder")
    }
  )), buttonData.type === ButtonData_Type.LINK && /* @__PURE__ */ React.createElement(
    LinkSettings,
    {
      linkValue: {
        url: (_a = buttonData.link) == null ? void 0 : _a.url,
        openInNewTab: ((_b = buttonData.link) == null ? void 0 : _b.target) === "BLANK",
        nofollow: (_d = (_c = buttonData.link) == null ? void 0 : _c.rel) == null ? void 0 : _d.nofollow,
        sponsored: (_f = (_e = buttonData.link) == null ? void 0 : _e.rel) == null ? void 0 : _f.sponsored
      },
      onChange: (value) => {
        setIsValidUrl == null ? void 0 : setIsValidUrl(true);
        const link = value.url ? __spreadProps(__spreadValues({}, buttonData.link), {
          url: value.url,
          target: value.openInNewTab ? Link_Target.BLANK : Link_Target.TOP,
          rel: {
            nofollow: Boolean(value.nofollow),
            sponsored: Boolean(value.sponsored)
          },
          anchor: void 0
        }) : void 0;
        if (value.url && !containsUrl(value.url)) {
          setIsValidUrl == null ? void 0 : setIsValidUrl(false);
        }
        onChange(__spreadProps(__spreadValues({}, buttonData), { link }));
      },
      options: {
        showNewTabCheckbox: true,
        showNoFollowCheckbox: true,
        showSponsoredCheckbox: true
      },
      inputRef
    }
  ));
};

export { SettingsComponent };
//# sourceMappingURL=settings-component.js.map
